module.exports = __webpack_public_path__ + "img/20210731_144744.85abb0ee.jpg";